import * as jsxRuntime from "C:\\Eidos!!!\\carlbrohaven\\45-eido-carlbrohaven\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment